var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8759 0.279286L16.5517 5.29134C15.5374 5.13255 14.504 5.13255 13.4897 5.29134L12.1449 0.279286C14.0442 -0.093136 15.9973 -0.093136 17.8966 0.279286C17.8966 0.279286 17.8759 0.279286 17.8759 0.279286Z",
    fill: "#1BA7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4724 5.82928C10.5124 6.2017 9.61857 6.72565 8.8241 7.38102L5.17236 3.68791C6.62789 2.41444 8.3182 1.43739 10.1482 0.812073L11.4724 5.82928Z",
    fill: "#1BA7E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36039 8.8241C6.70501 9.61857 6.18107 10.5124 5.80865 11.4724L0.791382 10.1275C1.42554 8.3032 2.40933 6.6201 3.68791 5.17236L7.36039 8.8241Z",
    fill: "#1BA7E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17242 15C5.17137 15.5193 5.21121 16.0386 5.29137 16.5517L0.279316 17.8965C-0.0931055 15.9972 -0.0931055 14.0441 0.279316 12.1448L5.29137 13.4483C5.21121 13.9619 5.17137 14.4806 5.17242 15Z",
    fill: "#1BA7E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3604 21.1759L3.68797 24.8276C2.4145 23.3721 1.43745 21.6818 0.812134 19.8518L5.8294 18.5069C6.1935 19.4726 6.71071 20.3741 7.3604 21.1759Z",
    fill: "#1BA7E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4724 24.1706L10.1275 29.1879C8.30478 28.56 6.62168 27.5829 5.17236 26.3121L8.84478 22.6396C9.6341 23.2856 10.5212 23.8024 11.4724 24.1706Z",
    fill: "#1BA7E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8759 29.7206C15.9766 30.0931 14.0235 30.0931 12.1241 29.7206L13.4483 24.7086C14.4626 24.8674 15.496 24.8674 16.5104 24.7086L17.8759 29.7206Z",
    fill: "#1BA7E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8276 26.3121C23.3721 27.5855 21.6818 28.5626 19.8518 29.1879L18.507 24.1706C19.467 23.7982 20.3607 23.2743 21.1552 22.6189L24.8276 26.3121Z",
    fill: "#1BA7E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1879 19.8724C28.56 21.6951 27.5829 23.3782 26.3121 24.8275L22.6396 21.1551C23.295 20.3607 23.819 19.4669 24.1914 18.5069L29.1879 19.8724Z",
    fill: "#1BA7E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30.002 15.9656 29.9085 16.9287 29.7207 17.8758L24.7086 16.5516C24.8674 15.5373 24.8674 14.5039 24.7086 13.4896L29.7207 12.1447C29.9069 13.0852 30.0005 14.0415 30 15Z",
    fill: "#1BA7E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.188 10.1275L24.1708 11.4724C23.7983 10.5124 23.2744 9.6186 22.619 8.82413L26.2914 5.1517C27.5721 6.60565 28.5564 8.29602 29.188 10.1275Z",
    fill: "#1BA7E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8276 3.6879L21.1552 7.36032C20.3607 6.70495 19.467 6.18101 18.507 5.80859L19.8518 0.791321C21.6833 1.42343 23.3737 2.40722 24.8276 3.6879Z",
    fill: "#1BA7E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.af2298e55d2eab6556e7cfbc6135f75b.svg";
export { ForwardRef as ReactComponent };